// ----------------------------------------------------------------------------
// Section: Featured Tiles
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------
import Swiper, { A11y, Keyboard } from 'swiper';

// Style includes
import 'swiper/css';
import 'swiper/css/a11y';
import 'swiper/css/keyboard';
import './_homepage-tiles.scss';

// -------------------------------------
// Variables
// -------------------------------------

// Selectors
const FEATURED_TILES_SLIDER_SELECTOR = '.carousel--featured-tiles-container';
const CAROUSEL_SELECTOR              = '.carousel--featured-tiles';

// -------------------------------------
// Helpers
// -------------------------------------

const initFeaturedTiles = (slider) => {
    const carousel   = slider.querySelector(CAROUSEL_SELECTOR);

    const swiper = new Swiper(carousel, {
        modules: [A11y, Keyboard],
        slidesPerView: 1.3,
        spaceBetween: 12,
        // centerInsufficientSlides: true,
        observer: true,
        observeParents: true,
        a11y: false,
        watchOverflow: true, // Do not turn into sliders if number of slides is less than slidesPerView.
        grabCursor: true,

        breakpoints: {
            480: {
                slidesPerView: 1.6,
                spaceBetween: 15,
            },
            680: {
                slidesPerView: 3,
                spaceBetween: 20,
            }
        }
    });

    swiper.slides.forEach(function(slide, index) {
        const slideLink = slide.querySelector('a');

        slideLink.addEventListener('focus', function(e) {
            swiper.slideTo(index);
        })
    });
}

// -------------------------------------
// Hooks
// -------------------------------------

document.addEventListener('DOMContentLoaded', () => {
    const featuredTilesSliders = document.querySelectorAll(FEATURED_TILES_SLIDER_SELECTOR);

    featuredTilesSliders.forEach((featuredTilesSlider) => {
        initFeaturedTiles(featuredTilesSlider);
    });
});